/**
 * Created by ivo on 22.05.14.
 *
 * Accordion component for destination pages
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'clientComponents/accordion/node'
    ],
    function($, Object, OptionsMixin, EventDispatcher, AccordionNode) {
        /**
         * Abstract pseudo class for the creational process of
         * the filter widgets.
         *
         * @constructor
         * @param {Object} scope
         * @param array An array of widgets to be instantiated
         * @returns {_L1.WidgetFactory}
         */
        var Accordion = function(requestHandler, scope, options) {
            EventDispatcher.apply(this, arguments);
            this._regionParamName = 'groupNames';

            // Set default options
            var defaultOptions = {
                elementSelector: '[data-fcse-role="accordion"]',
                loadingClass: 'is-loading'
            };
            this.addOptions(defaultOptions, options);

            // Save local variables
            this.requestHandler = requestHandler;
            this.scope = scope;

            // Get dom node
            var element = $(this.option('elementSelector'));
            if (element.length != 1){
                throw new Error('You have to have ONE node of accordion in the DOM');
            }
            this.element = $(element[0]);

            // Register an event on successful getting of data
            this.registerEvent("dataSuccess");

            // Initialize events
            this._initEventHandling();

            // Initialize accordion nodes
            this._initNodes();

        }

        Accordion.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{
            /**
             * An array of AccordionNode objects
             * @private
             */
            _nodes: [],

            /**
             * Returns all nodes
             */
            getNodes: function(){
                return this._nodes;
            },

            /**
             * Initializes event handling
             * @private
             */
            _initEventHandling: function(){
                // Register scope change handler
                this.scope.change($.proxy(this._onScopeChange, this));

                // Register requestHandler
                this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
            },

            /**
             * Handler for content loading success
             * @param response
             * @param data
             * @private
             */
            _onLoadContentSuccess: function(response, data){
                // Check if ajax response is from nodeContentRoute
                if (data.route !== this.option('contentRoute')){
                    return;
                }

                // Put HTML into DOM
                var newElement = $(response.html);
                $(this.element).replaceWith(newElement);
                this.element = newElement;

                // Initialize new nodes
                this._initNodes();

                // Dispatching the event on successful getting of data
                this.dispatchEvent("dataSuccess", response);
            },

            /**
             * Handler for content loading error
             * @param event
             * @private
             */
            _onLoadContentError: function(event){
                console.log('Error handling');
            },

            /**
             * Scope change handler
             * @param scope
             * @param params
             * @private
             */
            _onScopeChange: function(scope, params){
                // we have to reset filterGroupIds if we change groupIds
                if (scope.changedParams.includes('groupIds')) {
                    scope.scope.setMultipleParams({
                        'filterGroupIds': null,
                        'searchValue': null,
                        'hotelName': null,
                        'hotelId': null,
                        'productCode': null,
                    });
                } else if (scope.changedParams.includes('hotelName')) {
                    scope.scope.setMultipleParams({
                        'searchValue': null,
                        'hotelName': null,
                        'hotelId': null,
                        'productCode': null,
                    });
                }
                // we don't need update accordion if we update content in node
                if (scope.changedParams.includes('filterGroupIds')) {
                    return false;
                }

                // Reload accordion
                this.requestHandler.cancel(this.option('contentRoute'));
                this.requestHandler.send(this.option('contentRoute'), this.scope.getQuery());

                // Set loading state
                $(this.element).addClass(this.option('loadingClass'));
            },

            /**
             * Initializes all nodes
             * @private
             */
            _initNodes: function(){
                var self = this;

                this._resetFilterGroupIds();

                $('[data-fcse-role="accordion--node"]', this.element).each(function(index, element){
                    // Initialize node
                    var node = new AccordionNode(element, self.requestHandler, self.scope, {
                        nodeContentRoute: self.option('nodeContentRoute')
                    });

                    // Open first node
                    if (index == 0){
                        node.open();
                    }
                });
            },

            /**
             * Reset filter when we have more than one destination
             * @private
             */
            _resetFilterGroupIds: function () {
                const groupIdCount = $('[data-fcse-role="accordion--contentnode"]').length
                if (groupIdCount !== 1) {
                    this.scope.setParam('filterGroupIds', null);
                }
            }
        });

        return Accordion;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/accordion/accordion.js